/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import rootReducer from './reducer';
import appReducer from '../containers/App/reducer';
import registrationReducer, { key as regKey } from '../containers/Registration/reducer';
import HomeReducer, { key as HomeReducerKey } from '../containers/Home/reducer';
import SettingsReducer, { key as SettingsReducerKey } from '../containers/AccountSettings/reducer';
import ProductionUpdateSteps, { key as ProductionUpdateStepsKey } from '../containers/ProductionUpdateSteps/reducer';
import Company, { key as CompanyReducerKey } from '../containers/Company/reducer';
import festivalReducer from "../containers/Festival/reducer";

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const dynamicReducer = combineReducers({
    global: rootReducer,
    App: appReducer,
    Festival: festivalReducer,
    ...injectedReducers,
  });

  return dynamicReducer;
}

export const reducersList = [
  { key: regKey, reducer: registrationReducer },
  { key: HomeReducerKey, reducer: HomeReducer },
  { key: SettingsReducerKey, reducer: SettingsReducer },
  { key: ProductionUpdateStepsKey, reducer: ProductionUpdateSteps },
  { key: CompanyReducerKey, reducer: Company },
];
